import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import logo from '../assets/img/logo.png'; // Assuming the same logo is used
import { frameData, motion } from 'framer-motion';
import mamamtaimage from '../assets/img/mamata didi.jpg'; // Assuming the same decorative image
import ashokimage from '../assets/img/ashok.png'; // Assuming the same decorative image
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Assuming AuthContext is in this path
import { toast } from 'react-toastify';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const department = JSON.parse(localStorage.getItem('department'));

  useEffect(() => {
    if (isAuthenticated) {
      if (department && department === 'pwd') { 
        navigate('/pwdsection'); 
      } else if (department && department === "admin") {
        navigate('/admin-dashboard');
      }
      else{
        navigate("/dashboard")
      }
    }
  }, [isAuthenticated, navigate, department]); 

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append('email', username);
      formData.append('password', password);
      formData.append("modulename" , "AdminLogin")
      const response = await fetch(`https://pwd.smartstylin.in/index.php`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.code === 0) {
        toast.error(data.message || 'Login failed', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        login(data.user || { email: username }); 
        toast.success('Login successful', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        
        });
        localStorage.setItem("department",JSON.stringify("admin"))
       
         if (department && department === "admin"){
          navigate('/admin-dashboard')
        }
      }
    } catch (err) {
      toast.error('Login failed. Please try again.', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      console.error('Login error:', err);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center"
         style={{
           background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
           fontFamily: "'Poppins', sans-serif",
           padding: '2rem 0'
         }}>
      <div className="container">
        <div className="row align-items-center">
          {/* Left Image */}
          <motion.div
            className="col-md-3 d-none d-md-block"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="text-center">
              <img
                src={mamamtaimage} 
                alt="Decorative"
                className="img-fluid"
                style={{
                  maxHeight: '400px',
                  borderRadius: '50%',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                  border: '2px solid #1c82df'
                }}
              />
            </div>
          </motion.div>

          {/* Login Card */}
          <motion.div
            className="col-md-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="card shadow-lg p-4"
                 style={{
                   borderRadius: '15px',
                   border: 'none',
                   background: 'rgba(255, 255, 255, 0.9)',
                   backdropFilter: 'blur(10px)',
                   height: '100%'
                 }}>
              <div className="text-center mb-4">
                <motion.div
                  initial={{ scale: 0.8 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <img src={logo} alt="Logo" style={{ height: '100px', marginBottom: '1rem' }} />
                </motion.div>
                {/* Changed title to Admin Login */}
                <h2 className="text-primary fw-bold mb-3" style={{ fontSize: '1.8rem' }}>Admin Login</h2>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label fw-medium">Email</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0" style={{ padding: '0.75rem 1rem' }}>
                      <i className="bi bi-envelope-fill text-primary" style={{ fontSize: '1.2rem' }}></i>
                    </span>
                    <input
                      type="email"
                      className="form-control border-start-0"
                      placeholder="Enter your email"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                      style={{ padding: '0.75rem' }}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="password" className="form-label fw-medium">Password</label>
                  <div className="input-group">
                    <span className="input-group-text bg-light border-end-0" style={{ padding: '0.75rem 1rem' }}>
                      <i className="bi bi-lock-fill text-primary" style={{ fontSize: '1.2rem' }}></i>
                    </span>
                    <input
                      type="password"
                      className="form-control border-start-0"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      style={{ padding: '0.75rem' }}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="form-check">
                    <input type="checkbox" className="form-check-input" id="rememberMe" />
                    <label className="form-check-label text-muted" htmlFor="rememberMe">
                      Remember me
                    </label>
                  </div>
                  <Link to="#" className="text-primary text-decoration-none">
                    Forgot password?
                  </Link>
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  className="btn btn-primary w-100 py-2 mb-3 fw-medium"
                  style={{
                    borderRadius: '8px',
                    background: 'linear-gradient(45deg, #2196F3, #1976D2)',
                    border: 'none',
                    fontSize: '1rem'
                  }}
                >
                  Login
                </motion.button>
              </form>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div
            className="col-md-3 d-none d-md-block" // Corrected: d-none d-md-block ensures it's hidden on small screens and visible on medium and up
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="text-center">
            <img
                src={ashokimage} // Reusing image from ChairmanLogin
                alt="Decorative"
                className="img-fluid"
                style={{
                  maxHeight: '400px',
                  borderRadius: '50%',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                  border: '2px solid #1c82df'
                }}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;